import React from 'react';
import classNames from 'classnames';
import { find } from 'lodash-es';
import { Dropdown, SearchBox, Tabs } from 'tea-component';
import { useIntl } from 'umi';
import FileLibraryFilterIcon from '@/pages/aigc/assets/svg/icon-file-library-filter.svg';
import { FILE_LIBRARY_PAGE_TABS } from '../../constants';
import type { TFileLibraryQuery, TFileLibraryQueryInput } from '../../types';
import type { IAgentData } from '../../../AgentCollection/types';
import FilterPanel from '../FilterPanel';

/** Tab + 筛选 + 搜索工具栏 */
const FileLibraryToolbar: React.FC<{
  pageTabs: { id: string; label: string; }[];
  activeId: string;
  onTabChange: (tabId: string) => void;
  listQuery: TFileLibraryQuery;
  patchQuery: (patch: Partial<TFileLibraryQueryInput>) => void;
  searchDraft: string;
  onSearchChange: (text?: string) => void;
  activeFilterCount: number;
  agents: IAgentData[];
  agentsLoading?: boolean;
}> = ({
  pageTabs,
  activeId,
  onTabChange,
  listQuery,
  patchQuery,
  searchDraft,
  onSearchChange,
  activeFilterCount,
  agents,
  agentsLoading,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="dba-file-library__bar">
      <Tabs
        tabs={pageTabs}
        className="dba-file-library__tabs"
        activeId={activeId || 'all'}
        onActive={tab => {
          const next = find(
            FILE_LIBRARY_PAGE_TABS,
            item => item.id === tab.id,
          );
          if (!next) {
            return;
          }
          onTabChange(next.id);
        }}
      />
      <div className="dba-file-library__toolbar">
        <div className="dba-file-library__filter-wrap">
          <Dropdown
            trigger="click"
            appearance="pure"
            clickClose={false}
            placement="bottom-end"
            placementOffset={[0, 4]}
            boxClassName="dba-file-library-filter-box"
            button={
              <span
                className={classNames('dba-file-library__filter-btn', {
                  'dba-file-library__filter-btn--active':
                    activeFilterCount > 0,
                })}
              >
                <span className="dba-file-library__filter-icon" aria-hidden>
                  <img src={FileLibraryFilterIcon} alt="" />
                </span>
                <span className="dba-file-library__filter-label">
                  {formatMessage({ id: 'dba_file_library_filter' })}
                </span>
                {activeFilterCount > 0 ? (
                  <span className="dba-file-library__filter-count">
                    {activeFilterCount}
                  </span>
                ) : null}
              </span>
            }
          >
            <FilterPanel
              fileType={listQuery.fileType}
              timeRange={listQuery.timeRange}
              source={listQuery.source}
              agents={agents}
              agentsLoading={agentsLoading}
              onFileTypeChange={value => patchQuery({ fileType: value })}
              onTimeRangeChange={value => patchQuery({ timeRange: value })}
              onSourceChange={value => patchQuery({ source: value })}
              onClear={() =>
                patchQuery({
                  fileType: '',
                  timeRange: '',
                  source: null,
                })
              }
            />
          </Dropdown>
        </div>
        <SearchBox
          className="dba-search-box dba-file-library__search"
          placeholder={formatMessage({
            id: 'dba_file_library_search_placeholder',
          })}
          value={searchDraft}
          onChange={onSearchChange}
        />
      </div>
    </div>
  );
};

export default FileLibraryToolbar;
